import { createSelector } from 'reselect';
import { getCurrentStep } from 'state/steps/StepSelectors';

const getContentFragments = state => state.contentFragments;
export const getContentFragmentError = state => state.contentFragmentError;

export const getContentFragmentsForStep = createSelector(
  getCurrentStep,
  getContentFragments,
  (currentStep, contentFragments) => {
    return contentFragments && Object.keys(contentFragments).length ? contentFragments[currentStep] : [];
  }
);

export const getHasReceivedContentFragments = createSelector(
  getContentFragments,
  contentFragments => contentFragments && Object.keys(contentFragments).length > 0
);
